import { apiRequest } from "./client";

/**
 * NestJS contacts contract (Part 72 §72.2):
 * - GET    /api/contacts?q=&page=&size=    → { items, total, page, size }
 * - POST   /api/contacts                    → contact (fullName required)
 * - GET    /api/contacts/:id                → contact
 * - GET    /api/contacts/:id/timeline       → activity timeline
 * - POST   /api/contacts/:id/convert        → creates a deal (409 when already converted)
 * - PATCH  /api/contacts/:id                → contact
 * - DELETE /api/contacts/:id                → soft-delete (Owner/Manager)
 */
const LIST_SIZE = 200;

function deriveStats(items) {
  const totalContacts = items.length;
  const converted = items.filter((c) => c.convertedToDealId).length;
  const consented = items.filter((c) => c.whatsappConsent === "granted").length;
  return { totalContacts, converted, consented };
}

export const contactsApi = {
  getAll: async (q) => {
    const params = new URLSearchParams({ page: "1", size: String(LIST_SIZE) });
    if (q?.trim()) params.set("q", q.trim());
    const data = await apiRequest(`/api/contacts?${params}`);
    return (data?.items || []).map((contact) => ({
      ...contact,
      createdAtUtc: contact.createdAtUtc ?? contact.createdAt ?? null,
    }));
  },
  getStats: async () => deriveStats(await contactsApi.getAll()),
  get: (id) => apiRequest(`/api/contacts/${id}`),
  create: (payload) => apiRequest("/api/contacts", { method: "POST", body: JSON.stringify(payload) }),
  update: (id, payload) => apiRequest(`/api/contacts/${id}`, { method: "PATCH", body: JSON.stringify(payload) }),
  remove: (id) => apiRequest(`/api/contacts/${id}`, { method: "DELETE" }),
  timeline: (id) => apiRequest(`/api/contacts/${id}/timeline`),
  convert: (id, payload) => apiRequest(`/api/contacts/${id}/convert`, { method: "POST", body: JSON.stringify(payload) }),
};